import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from "redux-form";
import {renderTextField} from "./inputs/TextFeaild";
import {Button, Grid, withStyles} from "material-ui";

export class CategoryForm extends React.Component {

    render() {

        const {handleSubmit, errors, classes} = this.props;

        return (
            <form onSubmit={handleSubmit}>

                <Grid container alignItems="center">
                    <Grid item>
                        <Field
                            className={classes.field}
                            name="name"
                            err={errors.name}
                            component={renderTextField}
                            type="text"
                            placeholder="カテゴリ名"/>
                    </Grid>

                    <Grid item xs={1}>
                        <Button type="submit"
                                size="small"
                                color="primary"
                                variant="raised">
                            追加
                        </Button>
                    </Grid>
                </Grid>

            </form>
        )
    }
}

CategoryForm = withStyles((theme) => ({
    field: {
        marginTop: -8,
    }
}))(CategoryForm);

CategoryForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
};

CategoryForm = reduxForm({
    form: 'category'
})(CategoryForm);


// WEBPACK FOOTER //
// ./src/forms/category.js